<template>
    <div class="event container px-5 bg-dark">
        <b-row class="gx-5 align-items-center">
            <b-col lg="6">
                <b-row>
                    <b-col cols="12" class="text-center text-lg-start">
                        <h1 class="display-1 lh-1 mb-3 text-light">{{event.name}}</h1>
                        <p class="lead font-weight-normal text-light mb-5">{{title_date}}, {{title_time}} {{event.campus}}</p>
                    </b-col>
                    <b-col cols="12" class="text-center text-lg-start">
                        <p class="text-light pb-0">Es necesario tener instalado el cliente Zoom, ¿No lo tienes? </p>
                        <b-button
                            variant="outline-light" 
                            class="text-light mb-3" 
                            href="https://us02web.zoom.us/download"
                            target="_blank"
                        >
                            Descárgalo Aquí
                        </b-button>
                    </b-col>
                    
                    <b-col cols="12" class="text-center text-lg-start">
                        <b-button 
                            v-if="isLoggedIn && event.demo_mode===1" 
                            block 
                            pill
                            variant="danger"
                            class="h3 pt-3 pb-2 text-uppercase shadow border-lg border-primary" 
                            @click="$eventHub.$emit('joinZoom', 'sala_general')"
                        >
                            Unirse
                        </b-button>
                    </b-col>
                    <b-col cols="12" class="text-center text-lg-start">
                        <b-button 
                            v-if="isLoggedIn && event.enable_diploma===1"
                            block 
                            pill
                            variant="danger"
                            class="h3 pt-3 pb-2 text-uppercase shadow border-lg border-primary" 
                            @click="$eventHub.$emit('showDiploma')"
                        >
                            Obtener Constancia
                        </b-button>
                    </b-col>
                    <!-- <b-col cols="12" class="text-center text-lg-start">
                        <b-button 
                            v-if="isLoggedIn && event.enable_exam===1"
                            block 
                            pill
                            variant="danger"
                            class="h3 pt-3 pb-2 text-uppercase shadow border-lg border-primary" 
                            @click="$eventHub.$emit('showExam')"
                        >
                            Contestar Examen
                        </b-button>
                    </b-col> -->
                </b-row>
            </b-col>
            <b-col lg="6" class="p-5">
                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-button  
                            v-if="!isLoggedIn" 
                            block 
                            pill 
                            variant="danger" 
                            class="h3 pt-3 pb-2 text-uppercase shadow border-lg border-secondary" 
                            @click="$eventHub.$emit('showLogin')"
                        >
                            {{this.event.demo_mode?'Ingresar':this.event.finished?'Ingresar':'Registro'}}
                        </b-button>
                    </b-col>
                    <b-col cols="12">
                        <b-img class="rounded p-3 shadow" fluid :src="require('@/assets/img/logo.png')"></b-img>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
    name: "Event",
    data() {
        return {
            streaming_data: {
            id: 'streaming-general', 
            name: 'En vivo',
            urls: [
                {
                value: null, 
                text: "Idioma Seleccionado Español"
                },
                {
                value: null, 
                text: "Language Selected English"
                },
            ]
            },
        }
    },
    computed: {
        event() {
            return this.$store.getters.event 
        },
        isLoggedIn : function() {return this.$store.getters.isLoggedIn},
        title_date: function() {
            let resp = ''
            if(this.event.start_date) resp += moment(this.event.start_date).format('DD/MM/YYYY')
            return resp
        },
        title_time: function() {
            let resp = ''
            if(this.event.start_date) resp += moment(this.event.start_date).format('hh:mm A')
            return resp
        },
        secondStreamModule : function() { return this.$store.getters.getModule('SecondStream') },
    },
    methods: {
        showVideo(param) {
        if(param === 'second-stream') {
          if(this.secondStreamModule) {
            let data = JSON.parse(this.secondStreamModule.params)
            this.streaming_data = data
          }
        } else {
          this.streaming_data= {
            id: (this.secondStreamModule && this.secondStreamModule.active==1)?'streaming-neumologos': 'streaming-general', 
            name: (this.secondStreamModule && this.secondStreamModule.active==1)?'Sala Neumólogos': 'En vivo',
            urls: [
              {
                value: this.event.url_to, 
                text: "Idioma Seleccionado Español"
              },
              {
                value: this.event.redirect_to, 
                text: "Language Selected English"
              },
            ]
          }
        }
        this.$emit('video', this.streaming_data)
      },
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/app';

.event {
    
}

</style>